import { FDealType } from '../utils/category';

export const DEAL_TYPE_NAMES = {
  [FDealType.Sale]: 'Купить',
  [FDealType.RentLongterm]: 'Снять',
  [FDealType.RentDaily]: 'Посуточно',
};
